var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H8.62187L7.08437 0.585938C6.70937 0.210625 6.20312 0 5.67188 0H2C0.895313 0 0 0.895625 0 2V12C0 13.1044 0.895313 14 2 14H14C15.1047 14 16 13.1044 16 12V4C16 2.89687 15.1031 2 14 2ZM2 1.5H5.67188C5.80541 1.5 5.93103 1.552 6.02531 1.6465L8 3.5H14C14.2757 3.5 14.5 3.72425 14.5 4V5H1.5V2C1.5 1.72438 1.72438 1.5 2 1.5ZM14 12.5H2C1.72431 12.5 1.5 12.2758 1.5 12V6.5H14.5V12C14.5 12.275 14.275 12.5 14 12.5Z",
    fill: "#777777"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.e161b42ee697de2c87c2c95f6b4a33e4.svg";
export { ForwardRef as ReactComponent };